import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyAPIKeysProps {
  canWrite: boolean;
  onGenerate: () => void;
}

export const EmptyAPIKeys = ({ canWrite, onGenerate }: EmptyAPIKeysProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia>
          <img src="/assets/empty-states/api-keys.webp" alt="" />
        </EmptyMedia>
        <EmptyTitle>{t('developer_tools.api_keys_empty_title')}</EmptyTitle>
        <EmptyDescription>{t('developer_tools.api_keys_empty_description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={onGenerate} disabled={!canWrite}>
          <PlusIcon size={16} />
          {t('common.generate')}
        </Button>
      </EmptyContent>
    </Empty>
  );
};
